import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthChauffeur } from "./auth";
import axios from "axios";
import {
  Button,
  CssBaseline,
  TextField,
  Box,
  Typography,
  Container,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
// Retour au toast classique mais robuste
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Logo from "../../../assets/logo.png";

const apiUrl = process.env.REACT_APP_API_URL;

export const LoginChauffeur = () => {
  const [chauffeurs, setChauffeurs] = useState([]);
  const [selectedChauffeur, setSelectedChauffeur] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const { login } = useAuthChauffeur();
  const navigate = useNavigate();

  const stringToHex = (str) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(str);
    return Array.from(data)
      .map((byte) => byte.toString(16).padStart(2, "0"))
      .join("");
  };

  useEffect(() => {
    const fetchChauffeurs = async () => {
      try {
        const response = await axios.get(
          `${apiUrl}IHM/api/chauffeurs.php?AllChauffeurs`
        );
        setChauffeurs(response.data);
      } catch (error) {
        toast.error("Erreur de chargement des chauffeurs");
      }
    };
    fetchChauffeurs();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    if (!selectedChauffeur || !password) {
      toast.warning("Veuillez remplir tous les champs");
      return;
    }

    setLoading(true);
    const passwordHex = stringToHex(password);

    try {
      const response = await axios.post(
        `${apiUrl}IHM/api/login-chauffeur.php`,
        {
          nomPrenom: selectedChauffeur,
          password: passwordHex,
        }
      );

      if (response.data.success) {
        const user = response.data.user;

        localStorage.setItem("idChauffeur", user.idChauffeur);
        localStorage.setItem("nomChauffeur", user.nomPrenom);

        login(user);

        toast.success(`Bonjour ${user.nomPrenom} !`);

        navigate("/chauffeur/courses", { replace: true });
      } else {
        toast.error(response.data.message || "Identifiants invalides");
        setLoading(false);
      }
    } catch (error) {
      toast.error("Erreur serveur ou réseau");
      setLoading(false);
    }
  };
  return (
    <Container component="main" maxWidth="xs">
      <ToastContainer position="top-right" autoClose={3000} />

      <CssBaseline />
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          mt: { xs: 4, sm: 8 },
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          p: { xs: 2, sm: 4 },
          borderRadius: 3,
          bgcolor: "white",
          width: "100%",
          maxWidth: "400px",
          mx: "auto",
        }}
      >
        <img
          src={Logo}
          alt="Logo"
          style={{ width: "200px", marginBottom: "20px" }}
        />

        <Typography component="h1" variant="h5" sx={{ mb: 3 }}>
          Espace Chauffeur de navette
        </Typography>

        {/* <FormControl fullWidth margin="normal" required>
          <InputLabel id="select-chauffeur-label">Votre identifiant</InputLabel>
          <Select
            labelId="select-chauffeur-label"
            id="select-chauffeur"
            value={selectedChauffeur}
            label="Choisir votre nom"
            onChange={(e) => setSelectedChauffeur(e.target.value)}
          >
            {chauffeurs.map((c) => (
              <MenuItem key={c.idChauffeur} value={c.nomPrenom}>
                {c.nomPrenom}
              </MenuItem>
            ))}
          </Select>
        </FormControl> */}

        <TextField
          margin="normal"
          required
          fullWidth
          label="Votre identifiant"
          type="text"
          value={selectedChauffeur}
          onChange={(e) => setSelectedChauffeur(e.target.value)}
        />

        <TextField
          margin="normal"
          required
          fullWidth
          label="Mot de passe"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <Button
          type="submit"
          fullWidth
          variant="contained"
          disabled={loading} // Désactivé pendant le chargement
          sx={{ mt: 3, mb: 2 }}
        >
          {loading ? "Connexion..." : "Se connecter"}
        </Button>
      </Box>
    </Container>
  );
};
